<template>
  <v-main>
    <search-view
      :show-search-options="true"
      :search-options="getSearchKeys"
      :show-search-date-options="false"
      :show-search-date="true"
      :show-add-button="true"
      :is-recycle="true"
      :show-price-filter="true"
      :show-sort-options="true"
      @initEvent="searchEvent"
      @searchEvent="searchEvent"
      @reset="reset"
    ></search-view>

    <v-layout v-if="isAdmin || isStaff">
      <v-flex md4 xs12>
        <v-select
          class="ml-1"
          :items="vendorList"
          v-model="selectVendor"
          label="特約商店"
          item-value="vendorId"
          item-text="name"
          :color="Theme.GREEN"
        ></v-select>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex md1>
        <v-btn :color="Theme.GREEN" dark @click="exportToExcel"
          >匯出 Excel</v-btn>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex>
        <table-view
          :items="list"
          :columnKeys="getColumnKeys"
          :pagination="pagination"
          :loading="loading"
          @changePage="changePage"
          @cellEvent="cellEvent"
        />
      </v-flex>
    </v-layout>
  </v-main>
</template>

<script>
import TableView from "@/components/TableView";
import SearchView from "@/components/SearchView";
import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";

export default {
  name: "recycle",
  components: {
    TableView,
    SearchView,
  },
  mixins: [common],
  data() {
    return {
      startDate: "",
      endDate: "",
      status: 1,
      loading: false,
      searchValue: "",
      vendorList: [],
      selectVendor: "",
      pagination: {
        page: 1,
        itemsPerPage: 30,
        totalItems: 0,
      },
      list: [],
      editView: {
        event: "add",
        visible: false,
        item: null,
        showCancel: true,
        confirmEvent: () => {},
        cancelEvent: () => {},
      },
      priceFilter: {
        type: -1,
        value: 0
      },
      sortBy: ''
    };
  },
  created() {
    this.loadVendorList();
    if (this.isVendor) {
      this.selectVendor = this.getUserInfo.userId;
    }
    this.loadData();
  },
  computed: {
    ...mapGetters([]),
    getColumnKeys() {
      let list = [];
      if (this.isStaff || this.isAdmin) {
        list = [
          // { value:'edit', text:'編輯' , isEvent: true, color: this.Theme.GREEN, sortable: false },
          { value: "prizeId", text: "回收編號", sortable: false },
          { value: "imageUrl", text: "商品", sortable: false, isImage: true },
          { value: "email", text: "Email", sortable: false },
          { value: "nickname", text: "會員暱稱", sortable: false },
          { value: "productName", text: "商品名稱", sortable: true },
          { value: "category", text: "類別", sortable: false },
        ];
        list.push({ value: "price", text: "回收金額", sortable: false });
        list.push({ value: "weight", text: "體積", sortable: false });
        list.push({ value: "createdDate", text: "回收時間", sortable: false });
        // 添加退回商品的按鈕
        list.push({
          value: "return",
          text: "退回",
          isEvent: true,
          color: "#F29B87",
          sortable: false,
          event: "return",
        });
      } else {
        list = [
          // { value:'edit', text:'編輯' , isEvent: true, color: this.Theme.GREEN, sortable: false },
          { value: "prizeId", text: "回收編號", sortable: false },
          { value: "imageUrl", text: "商品", sortable: false, isImage: true },
          { value: "nickname", text: "會員暱稱", sortable: false },
          { value: "productName", text: "商品名稱", sortable: true },
          { value: "category", text: "類別", sortable: false },
        ];
        list.push({ value: "price", text: "回收金額", sortable: false });
        list.push({ value: "weight", text: "體積", sortable: false });
        list.push({ value: "createdDate", text: "回收時間", sortable: false });
      }

      return list;
    },
    getSearchKeys() {
      return [
        { key: "name", value: "商品名稱" },
        { key: "prizeId", value: "回收編號" },
        { key: "userId", value: "會員編號" },
      ];
    },
  },
  methods: {
    ...mapActions([
      "loadProductRecycleList",
      "deleteProductInfo",
      "copyProductInfo",
      "getVendorList",
    ]),
    async loadVendorList() {
      try {
        const res = await this.getVendorList();
        const result = res.data;
        if (result.statusCode === 0) {
          this.vendorList = result.data;
        }
      } catch (e) {
        console.log(`getVendorList error `, e);
      }
    },
    async loadData() {
      try {
        let searchQuery = [];
        console.log(`searchKey ${this.searchKey} / searchValue ${this.searchValue}`);
        if (this.searchKey && this.searchKey !== "" && this.searchValue && this.searchValue !== "") {
          searchQuery.push({ key: this.searchKey, value: this.searchValue });
        }
        const start = `${this.startDate} 00:00:00`;
        const end = `${this.endDate} 23:59:59`;

        if (this.isDifferenceMoreThanAMonth(start, end)) {
          this.showMessageDialog("查詢時間不可超過一個月！");
          return;
        }

        this.loading = true;
        const res = await this.loadProductRecycleList({
          startDate: start,
          endDate: end,
          pageIndex: this.pagination.page,
          limit: this.pagination.itemsPerPage,
          searchQuery: searchQuery,
          vendorId: this.selectVendor
            ? this.selectVendor
            : this.getUserInfo.userId,
          priceFilterType: this.priceFilter.type,
          priceFilterValue: this.priceFilter.type === -1 ? '' : Number(this.priceFilter.value),
          sortBy: this.sortBy,
        });

        if (res.data.statusCode === 0) {
          this.list = res.data.data.list;
          this.pagination.totalItems = res.data.data.header.totalCount;
        }
        this.loading = false;
      } catch (e) {
        console.log(`loadProductRecycleList error `, e);
        this.loading = false;
      }
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page) {
      this.pagination.page = page.page;
      if (page.itemsPerPage === -1) {
        this.pagination.itemsPerPage = 1000;
      } else {
        this.pagination.itemsPerPage = page.itemsPerPage;
      }
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell) {
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === "delete") {
        this.showAlert({
          title: "提示",
          content: "是否確定要刪除此商品？",
          confirmEvent: async () => {
            this.hideAlert();
            await this.deleteEvent(cell.item);
          },
        });
      } else if (cell.key === "copy") {
        this.copyEvent(cell.item);
      } else if (cell.key === "return") {
        /* TODO 處理退回商品的事件 */
        // this.returnProduct(cell.item);
      } else {
        if (!cell.item.prizeList) {
          cell.item.prizeList = [];
        }

        this.editView.title = cell.key === "add" ? "新增商品" : "修改商品";
        this.editView.event = cell.key;
        this.editView.item = cell.item;
        this.editView.visible = true;
        this.editView.cancelEvent = () => {
          this.editView.visible = false;
        };
        this.editView.confirmEvent = () => {
          this.editView.visible = false;
          this.loadData();
        };
      }
    },
    searchEvent(info) {
      console.log(`searchEvent ${JSON.stringify(info)}`);
      this.startDate = info.startDate;
      this.endDate = info.endDate;
      this.searchKey = info.searchKey;
      this.searchValue = info.searchValue;

      // 處理價格篩選
      if (info.priceFilter) {
        this.priceFilter = info.priceFilter;
      }

      // 處理排序方式
      this.sortBy = info.sortBy;

      this.loadData();
    },
    reset() {
      this.searchValue = "";
      this.priceFilter = {
        type: -1,
        value: 0
      };
      this.sortBy = '';
      this.loadData();
    },
    async deleteEvent(item) {
      const res = await this.deleteProductInfo({
        isDelete: true,
        productId: item.productId,
      });

      if (res.data.statusCode === 0) {
        this.loadData();
        this.reset();
      }
    },
    showMessageDialog(content) {
      console.log(`showAlert ${content}`);
      this.showAlert({
        title: "提示",
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        },
      });
    },
    // 匯出 excel
    async exportToExcel() {
      try {
        const XLSX = require("xlsx"); // 動態導入xlsx

        // 使用 list 的數據
        const exportList = this.list.map((item) => ({
          回收編號: item.prizeId,
          商品: item.imageUrl,
          Email: item.email,
          會員暱稱: item.nickname,
          商品名稱: item.productName,
          類別: item.category,
          回收金額: item.price,
          體積: item.weight,
          回收時間: item.createdDate,
        }));

        // 創建一個工作表
        const worksheet = XLSX.utils.json_to_sheet(exportList);

        // 創建一個工作簿並將工作表添加進去
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // 將工作簿導出為Excel文件
        XLSX.writeFile(workbook, "回收紀錄.xlsx");
      } catch (e) {
        console.log(`export error `, e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
